import { defineMessages } from 'react-intl'

export default defineMessages({
  welcome: {
    id: 'onboarding.welcome',
    defaultMessage: "Welcome to Sijilo, let's get you started!"
  },
  getStarted: {
    id: 'onboarding.getStarted',
    defaultMessage: 'Get started'
  },
  personalInfo: {
    id: 'onboarding.personalInfo',
    defaultMessage: 'Personal Information'
  },
  firstName: {
    id: 'onboarding.firstName',
    defaultMessage: 'First Name'
  },
  lastName: {
    id: 'onboarding.lastName',
    defaultMessage: 'Last Name'
  },
  phone: {
    id: 'onboarding.phone',
    defaultMessage: 'Phone'
  },
  address: {
    id: 'onboarding.address',
    defaultMessage: 'Address'
  },
  city: {
    id: 'onboarding.city',
    defaultMessage: 'City'
  },
  next: {
    id: 'onboarding.next',
    defaultMessage: 'Next'
  },
  paymentInfo: {
    id: 'onboarding.paymentInfo',
    defaultMessage: 'Payment Information'
  },
  visitPrice: {
    id: 'onboarding.visitPrice',
    defaultMessage: 'Visit Price'
  },
  followUpPrice: {
    id: 'onboarding.followUpPrice',
    defaultMessage: 'Follow Up Price'
  },
  clinicInfo: {
    id: 'onboarding.clinicInfo',
    defaultMessage: 'Clinic Information'
  },
  clinicSpecialization: {
    id: 'onboarding.clinicSpecialization',
    defaultMessage: 'Clinic Specialization'
  },
  submit: {
    id: 'onboarding.submit',
    defaultMessage: 'Submit'
  },
  alreadyOnboarded: {
    id: 'onboarding.alreadyOnboarded',
    defaultMessage: 'You are already onboarded!'
  },
  alreadyOnboardedDescription: {
    id: 'onboarding.alreadyOnboardedDescription',
    defaultMessage: 'You are already onboarded, welcome back to Sijilo!'
  },
  success: {
    id: 'onboarding.success',
    defaultMessage: 'Successfully onboarded!'
  },
  successDescription: {
    id: 'onboarding.successDescription',
    defaultMessage: 'Your profile has been successfully updated, welcome to Sijilo!'
  }
})
